export function PlinkoGameBody() {
  return <div id="plinko" />;
}
